export default interface ConnectorFilter {
  filterValueType: ConnectorFilterValueType;
  values: string[];
}

export enum ConnectorFilterValueType {
  Type = 'Type',
  Location = 'Location',
  Monitor = 'Monitor',
}
